import type {RouteRecordRaw} from "vue-router";

export const routeName = 'NotificationMobile';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'notification',
    component: () => import('@/pages/Notification'),
    meta: {
        isHide: true,
    }
};
